<template>
    <a-modal
    title="设置用户分组"
    :bodyStyle="{'max-height': '600px', 'overflow-y': 'auto'}"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideModal"
  >

    <h4 class="table-title">
      <span style="margin-right:10px;">
        共有 <span class="number">{{groupData.length}}</span> 个用户组
      </span>
      <span>
        已勾选 <span class="number">{{selectedGruopIds.length}}</span> 个
      </span>
    </h4>
    <SelectableTable
      :columns="groupColumns"
      :dataSource="groupData"
      :selectedRowKeys="selectedGruopIds"
      :visible="visible"
      @selectedChange="keys => selectedGruopIds = keys"
    />
  </a-modal>
</template>

<script>
import { GetUserGroup, IndexUserDivideForUser } from '@/apis/userGroup'

import SelectableTable from '@/components/SelectableTable'

export default {
  name: 'SetGruopModal',
  components: { SelectableTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    targetUser: {
      type: Object,
      default: () => {}
    },
    defaultChecked: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      confirmLoading: false,

      groupColumns: [
        { title: '用户组名称', dataIndex: 'name', key: 'name' },
        { title: '描述', dataIndex: 'description', key: 'description' }
      ],
      groupData: [],
      selectedGruopIds: []
    }
  },
  created() {
    this.getAllGroups()
  },
  computed: {},
  watch: {
    visible: function(data) {
      if (data) {
        this.getUserGroups()
        // this.selectedGruopIds = data.map(group => group.id)
      }
    }
  },
  methods: {
   // 获取当前用户所属于的用户组列表
    async getUserGroups() {
      let self = this
      let userId = self.targetUser.id
      const { collection: data } = await IndexUserDivideForUser({userId:userId, page: 1, prePage: 100})
      this.groupData = data.map(g => {
        if (g.isJoin){
          self.selectedGruopIds.push(g.id)
        }
        return Object.assign(g, { key: g.id })
      })
    },
    //获取用户当前所有的用户组列表
    async getAllGroups() {
      try {
        const { collection: data } = await GetUserGroup({
          page: 1,
          perPage: 9999
        })
        this.groupData = data.map(g => {
          return Object.assign(g, { key: g.id })
        })
      } catch (error) {}
    },

    handlerSubmit() {
      const submitData = this.groupData.map(group => {
        const isAdd = this.selectedGruopIds.indexOf(group.id) !== -1
        return { isAdd, userGroupId: group.id }
      })
      this.$emit('submit', submitData)
      this.confirmLoading = true
    },

    afterHideModal() {
      this.confirmLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 800px !important
  }
  .table-title{
    color: #6c6c6c;

    .title {
      font-size: 16px;
    }
    .number {
      color: #1890FF;
      font-weight: bold
    }
  }
  .table-title:before{
    content: "";
    margin-right: 10px;
    border: 2px solid #1890ff;
    border-radius: 5px;
  }
</style>
